import {
  Applicant,
  InsuredPeopleDto,
  OnboardingPeriodDto,
} from '@zorro/clients';
import { calculateAgeForEnrollment } from '@zorro/common-utils';

export const getApplicantsFromWhoIsEnrolled = (
  insured: InsuredPeopleDto,
  whoIsEnrolled: string[],
  targetEnrollmentDate: OnboardingPeriodDto['effectiveFrom'],
  email: string
): Applicant[] => {
  const applicants: Applicant[] = [];
  if (whoIsEnrolled.length === 0) return applicants;

  const employeeSelected = whoIsEnrolled.find(
    (id) => id === insured.employee.id
  );

  if (employeeSelected) {
    applicants.push({
      age: calculateAgeForEnrollment(
        insured.employee.dateOfBirth,
        targetEnrollmentDate
      ),
      isSmoker: insured.employee.isSmoker,
      isChild: false,
      dateOfBirth: insured.employee.dateOfBirth,
      lastName: insured.employee.lastName,
      firstName: insured.employee.firstName,
      isEmployee: true,
      email,
    });
  }

  const spouseSelected = whoIsEnrolled.find((id) => id === insured.spouse?.id);

  if (spouseSelected && insured.spouse) {
    applicants.push({
      age: calculateAgeForEnrollment(
        insured.spouse.dateOfBirth,
        targetEnrollmentDate
      ),
      isSmoker: insured.spouse.isSmoker,
      isChild: false,
      dateOfBirth: insured.spouse.dateOfBirth,
      lastName: insured.spouse.lastName,
      firstName: insured.spouse.firstName,
      isEmployee: false,
    });
  }

  insured.dependents.forEach((dependent) => {
    const foundDependent = whoIsEnrolled.find((id) => id === dependent.id);
    if (foundDependent) {
      const age = calculateAgeForEnrollment(
        dependent.dateOfBirth,
        targetEnrollmentDate
      );
      applicants.push({
        age,
        isSmoker: dependent.isSmoker,
        isChild: age < 26,
        dateOfBirth: dependent.dateOfBirth,
        lastName: dependent.lastName,
        firstName: dependent.firstName,
        isEmployee: false,
      });
    }
  });

  return applicants;
};
